export default {
    computed: {
        // 插件input数据
        $inputDataMixin() {
            if (this.$store) {
                return this.$store.state.DestAirlineSearch.inputData;
            }
        },
        // input绑定的model变量
        $inputModelMixin() {
            return this.$store.state.DestAirlineSearch.inputModel;
        }
    },
    watch: {
        // 当插件推送数据、绑定到modelData上
        $inputDataMixin(newValue) {
            this[this.$inputModelMixin] = newValue;
        }
    },
    methods: {
        /**
         *
         * @param ev (event)
         * @param model (绑定的变量字符串)(ps:必须是最外层)
         * @param style (样式)
         * @param productNo (产品编号)
         */
        $destAirlineSearch(ev, model, style = {}, productNo = '') {
            if (this.$(ev.target).attr('data-trigger') === '1') {
                this.$(ev.target).removeAttr('data-trigger');// 删除模拟点击属性
                return;
            }
            const commit = style;
            commit.sel = ev.target;
            commit.inputModel = model;
            commit.inputData = this[model];
            this.$store.commit('DestAirlineSearch/ReloadPlugin', commit);
            this.$store.commit('DestAirlineSearch/productNo', productNo);
        },
    }
};
